import styled, { css } from 'styled-components';
import { mq, maxContentWidth, px2rem, getSpace } from '../../../stylesheets/tools';

const StyledContainer = styled.div`
  ${props =>
    !props.fill &&
    css`
      margin: 0 auto;
      width: 100%;
      ${props.large ? maxContentWidth('1340px') : maxContentWidth()}

      .container__wrapper {
        position: relative;
        margin: 0 ${props.fillOnMobile ? '0' : px2rem('24px')};

        ${mq('m')} {
          margin: 0 ${px2rem('46px')};
        }
      }

      .gomusShopLink {
        display: block;
        margin-bottom: ${getSpace('xl')};
      }
    `}
`;

export default StyledContainer;
